let _ = require('lodash');
let { monkey } = require('baobab');
let moment = require('moment');
const DATE_FORMAT = 'DD.MM.YYYY';
let { pluralize } = require('../../../helpers/utils');
let { Query } = require('catberry-uri');
let orderStateNameHolder = require('../../../helpers/orderStateNameHolder');

/**
 * Подготовка заголовка для селектора рубрик
 * @param {Array} allOptions
 * @param {Object} selectedOptions
 * @returns {String}
*/
function prepareTitle (allOptions, selectedOptions) {
    let selectionNum = selectedOptions.length;
    let title = `${pluralize(selectionNum, ['Выбран', 'Выбрано', 'Выбрано'])} ${selectionNum}
                        ${pluralize(selectionNum, ['статус', 'статуса', 'статусов'])}`;

    if (allOptions.length == selectionNum) {
        return 'Все статусы';
    } else if (selectionNum == 0) {
        return 'Выберите статусы';
    }

    return title;
}

module.exports = {
    /**
     * Красиво форматируем список заказов
     * @param {Object} state
     */
    formatOrderList (state) {
        // форматируем список закозов и особую инфу выбранного заказа
        state.set(['account', 'orders', 'computed', 'ordersList'], monkey(
            ['account', 'orders', 'list', 'data'],
            ['account', 'orders', 'currentOrder', 'id'],
            (ordersList = [], currentOrderId = '') => _.map(ordersList, (item) => ({
                id: item.id,
                name: item.name,
                createDate: moment(item.createDate).format(DATE_FORMAT),
                isSelected: item.id === currentOrderId,
                stateId: Number(item.stateId),
                stateName: orderStateNameHolder.getOrderStateName(item.stateId),
                userNameMarkedup: item.userNameMarkedup && item.userNameMarkedup.length > 0 ? item.userNameMarkedup : undefined,
                userEmailMarkedup: item.userEmailMarkedup && item.userEmailMarkedup.length > 0 ? item.userEmailMarkedup : undefined,
                idMarkedup: item.idMarkedup && item.idMarkedup.length > 0 ? item.idMarkedup : undefined,
                nameMarkedup: item.nameMarkedup && item.nameMarkedup.length > 0 ? item.nameMarkedup : undefined,
            }))
        ));
    },

    computeSelectedStatesArray (state) {
        state.set(['account', 'orders', 'computed', 'list', 'selectedStates'], monkey(
            ['account', 'orders', 'list', 'stateFilter'],
            (stateFilter) => {
                let status;
                if (stateFilter) {
                    status = [];
                    _.forEach(Object.keys(stateFilter), function(key) {
                        if (stateFilter[key].isChecked === true && !isNaN(key)) {
                            status.push(Number(key));
                        }
                    });
                }
                return status;
            }
        ));
    },

    computeSelectedTypesArray (state) {
        state.set(['account', 'orders', 'computed', 'list', 'selectedTypes'], monkey(
            ['account', 'orders', 'list', 'typeFilter'],
            (typeFilter) => {
                let type;
                if (typeFilter) {
                    type = [];
                    _.forEach(Object.keys(typeFilter), function(key) {
                        if (typeFilter[key].isChecked === true && !isNaN(key)) {
                            type.push(Number(key));
                        }
                    });
                }
                return type;
            }
        ));
    },

    queryObject (state) {
        // форматируем список закозов и особую инфу выбранного заказа
        state.set(['account', 'orders', 'computed', 'query'], monkey(
            ['account', 'orders', 'list', 'selectedRadioFilter'],
            ['account', 'orders', 'computed', 'list', 'selectedStates'],
            ['account', 'orders', 'list', 'selectedTypeFilter'],
            ['account', 'orders', 'list', 'filterText'],
            ['account', 'orders', 'computed', 'list', 'selectedTypes'],
            (assigned, status, orderTypeForUser, text, orderTypeForManager) => {
                let type = orderTypeForUser || orderTypeForManager || undefined;
                let queryObj = _.omitBy({ assigned, status, type, text }, _.isUndefined);

                let query = new Query();
                query.values = queryObj;

                return query.toString();
            }
        ));
    },

    /**
     * Устанавливаем фильтры в зависимости от роли пользователя
     * @param {Object} args
     * @param {Object} state
     */
    setOrdersFilters (args, state) {
        const FILTERS = [
            {
                title: 'Активные заказы',
                value: 'active',
                form: 'circle',
                color: 'green'
            },
            {
                title: 'Неактивные заказы',
                value: 'inactive',
                form: 'circle',
                color: 'gray'
            },
            {
                title: 'Все заказы',
                value: 'all',
                form: 'circle',
                color: 'transparent'
            }
        ];

        state.set(['account', 'orders', 'computed', 'ordersOriginalFilters'], monkey(
            ['user', 'role'],
            (role) => {
                if (role === 'client') {
                    return _.reject(FILTERS, { value: 'myOrders' });
                }
                if (role === 'unauthorized') {
                    return _.filter(FILTERS, { value: 'all' });
                }

                return FILTERS;
            }
        ));
    },

    /**
     * Выбор фильтра для списка заказов
     * @param {Object} args
     * @param {Object} state
     */
    setActiveOrdersFilter (args, state) {
        state.set(['account', 'orders', 'computed', 'typeFilter'], monkey(
            ['account', 'orders', 'computed', 'ordersOriginalFilters'],
            ['account', 'orders', 'list', 'selectedTypeFilter'],
            ['account', 'orders', 'ui', 'typeFilter', 'isDisabled'],
            (filters, currentFilter, isDisabled) => {
                let options = _.map(filters, (item) => Object.assign({ isActive: currentFilter == item.value }, item));

                return { options, isDisabled };
            }
        ));
    },

    /**
     * Выбор статусов заказа
     * @param {Object} args
     * @param {Object} state
     */
    setStatusSelect (args, state) {
        state.set(['account', 'orders', 'computed', 'statusFilter'], monkey(
            ['account', 'orders', 'list', 'statusFilterData'],
            ['account', 'orders', 'list', 'selectedStatus'],
            (allStatus, selectedStatus = []) => {
                let options = _.map(allStatus, (status) => ({
                    isSelected: _.includes(selectedStatus, status.id),
                    key: status.id,
                    name: status.name
                }));

                let title = prepareTitle(options, selectedStatus);
                let allSelected = options.length === selectedStatus.length;
                let allUnchecked = !selectedStatus.length;

                return { options, title, allSelected, allUnchecked };
            }
        ));
    },

    /**
     *
     * @param {Object} args
     * @param {Object} state
     */
    setRadioFilter (args, state) {
        state.set(['account', 'orders', 'computed', 'assignType'], monkey(
            ['account', 'orders', 'list', 'selectedRadioFilter'],
            (selectedKey = 'all') => {
                let defaultState = {
                    all: false,
                    my: false,
                    unassigned: false
                };

                defaultState[selectedKey] = true;

                return defaultState;
            }
        ));
    },

    computeIsRadioFilterActive (args, state) {
        state.set(['account', 'orders', 'computed', 'list', 'isAssignTypeFilterActive'], monkey(
            ['account', 'orders', 'list', 'selectedRadioFilter'],
            (selectedRadioFilter) => selectedRadioFilter && selectedRadioFilter !== "any"
        ));
    },
};



// WEBPACK FOOTER //
// ./actions/computed/account/orders-list.js